import React, { useContext } from 'react'
import { AppRouteCreators } from '@chegg-wt/core/types/core'

const RoutesContext = React.createContext({} as AppRouteCreators)

// TODO: Should this be in the `hooks` path instead?
export const useRoutesContext = () => useContext(RoutesContext)

export const RoutesProvider = RoutesContext.Provider

export default RoutesContext
